import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { ChatbotComponent } from '@ls-commons/chatbot';
import { UpdateNoticeComponent } from './services/app-update/update-notice.component';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet, ChatbotComponent, UpdateNoticeComponent],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
})
export class AppComponent {
  title = 'scubamedic-angular';

  layoutMode = 'overlay';

  darkMenu = false;

  isRTL = false;
}
